import { render, staticRenderFns } from "./client-layout.vue?vue&type=template&id=fc311356&scoped=true"
import script from "./client-layout.vue?vue&type=script&lang=js"
export * from "./client-layout.vue?vue&type=script&lang=js"
import style0 from "./client-layout.vue?vue&type=style&index=0&id=fc311356&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc311356",
  null
  
)

export default component.exports